import axiosInstance from '../axios-instance';
import { ApiResponse } from '@shared/models/api.model';
import { MoviesModel } from '@modules/entertainment/models/movies.model';

export const getMovies = async (
  params?: any
): Promise<ApiResponse<MoviesModel>> => {
  const response = await axiosInstance.get('/media/movies/getter', { params });
  return response.data;
};

export const createMovies = async (
  body?: any
): Promise<ApiResponse<MoviesModel>> => {
  return await axiosInstance.post(`/media/movies`, body);
};

export const editMoviesRow = async (
  body: any,
  id: any
): Promise<ApiResponse<MoviesModel>> => {
  return await axiosInstance.put(`/media/movies/${id}`, body);
};

export const deleteMovie = async (id: string): Promise<void> => {
  return await axiosInstance.delete(`/media/movies/${id}`);
};

export const deleteMoviesMany = async (id: string[]): Promise<void> => {
  const data = { ids: id };
  await axiosInstance.delete(`/media/movies/many`, { data });
};
